import { inject, Injectable } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';

import { NotificationModel } from '../models/notification.model';
import { NotificationsResource } from './resources/notifications.resource';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    readonly maxDays = 30;

    isOverlayOpenChange: Observable<boolean>;

    private isOverlayOpen = false;
    private isOverlayOpenSubject = new Subject<boolean>();

    private readonly notificationsResource = inject(NotificationsResource);

    constructor() {
        this.isOverlayOpenChange = this.isOverlayOpenSubject.asObservable();
    }

    toggleOverlay(isOpen?: boolean): void {
        this.isOverlayOpen = isOpen !== undefined ? isOpen : !this.isOverlayOpen;
        this.isOverlayOpenSubject.next(this.isOverlayOpen);
    }

    getNotifications(includeConfirmed?: boolean): Observable<NotificationModel[]> {
        return this.notificationsResource.getAll(includeConfirmed, this.maxDays).pipe(map(response => response.value ?? []));
    }

    markAsConfirmed(id: string): Observable<boolean> {
        return this.notificationsResource.markAsRead(id).pipe(map(result => result.value?.isSuccessful));
    }
}
